module.exports = __webpack_public_path__ + "media/images/pic/brodno/hero-kids-56c4d1d11337f00b0e6986518c1827c5.png";